// extracted by mini-css-extract-plugin
export var ArticleHeader = "ArticleHeader-module--ArticleHeader--988dc";
export var introduction = "ArticleHeader-module--introduction--9f485";